import React, { useEffect, useState } from 'react';


/*
*Example
<ObjectSelect
    options={animatedOptions}
    labelKey={'label'}
    onChange={(obj) => console.log(obj)}
/>
*/

function ObjectSelect({
    options,
    labelKey,
    mapKey = 'mpkselect_',
    onChange, selectStyle,
    containerStyle,
    selectClass,
    labelSelectFocusedClass,
    labelSelectHasValueClass,
    ...props
}) {
    const [selectedValue, setSelectedValue] = useState('');

    const handleChange = (event) => {
        const value = event.target.value;
        setSelectedValue(value);
        const selectedObject = options.find(option => option[labelKey] === value);
        onChange(selectedObject);
    };

    const getSelectClasses = () => {
        const baseClasses = `block w-full py-2 pl-3 pr-10 border-b border-gray-300 outline-none shadow-sm focus:ring-blue-500 focus:border-blue-500 sm:text-sm cursor-pointer appearance-none bg-white ${selectClass}`
        return baseClasses;
    };

    const getPlaceholderClasses = (hasValue, isFocused) => {
        const baseClasses = 'absolute left-0 top-2 text-md text-gray-500 pointer-events-none transition-all duration-200 ease-in-out bg-transparent px-1';
        const focusedClasses = `top-[-0.5rem] left-2 text-xs text-blue-500 bg-white ${labelSelectFocusedClass}`
        const hasValueClasses = `top-[-0.5rem] left-[-1px] text-xs text-gray-700 bg-white text-gray-400 ${labelSelectHasValueClass}`

        if (isFocused) {
            return `${baseClasses} ${focusedClasses}`;
        }
        if (hasValue) {
            return `${baseClasses} ${hasValueClasses}`;
        }
        return baseClasses;
    };

    const hasValue = selectedValue !== '';
    const [isFocused, setIsFocused] = useState(false);

    useEffect(() => {
        if (props?.value) {
            setSelectedValue(props.value)
        }
    }, [])




    return (
        <div className="relative inline-block w-full" style={containerStyle}>
            <select
                className={getSelectClasses()}
                style={selectStyle}
                value={selectedValue}
                onChange={handleChange}
                onFocus={() => setIsFocused(true)}
                onBlur={() => setIsFocused(false)}
            // {...props}
            >
                {/* <option value="" disabled hidden>{props.placeholder}</option> */}
                <option value="" disabled hidden></option>
                {options.map((option, index) => (
                    <option key={`${mapKey}${index}`} value={option[labelKey]}>
                        {option[labelKey]}
                    </option>
                ))}
            </select>
            <label htmlFor={props.id} className={getPlaceholderClasses(hasValue, isFocused)}>
                {props.placeholder}
            </label>
            <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                <svg className="h-5 w-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                    <path fillRule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clipRule="evenodd" />
                </svg>
            </div>
        </div>
    );
}

export default ObjectSelect;
